import { ApiUrl } from '@common/enums';
import { ApplianceModel } from '@common/models';
import { CommonProductQueryParams } from '@ee-api/queryParams';

import { staticContentService } from '../staticContentService';

const refrigeratorsApi = staticContentService.injectEndpoints({
    endpoints: (builder) => ({
        fetchInStoreRefrigerators: builder.query<ApplianceModel[], { url: string }>({
            query: ({ url }) => ({
                method: 'GET',
                url,
            }),
        }),
        fetchProgramRefrigerators: builder.query<ApplianceModel[], CommonProductQueryParams>({
            query: ({ params }) => {
                return {
                    url: ApiUrl.REFRIGERATORS,
                    method: 'GET',
                    params,
                };
            },
        }),
    }),
});

export const { useFetchInStoreRefrigeratorsQuery, useFetchProgramRefrigeratorsQuery } = refrigeratorsApi;
